import './DuplicateEntryWarning.css';

const DuplicateEntryWarning = ({ 
  message = "Duplicate entry detected. This record already exists in the system.",
  onClose = () => console.log('Close action')
}) => {
  return (
    <div className="duplicate-warning-container">
      <div className="duplicate-warning-alert" role="alert">
        {/* Icon and content */}
        <div className="warning-content-compact">
          <i className="bx bx-error-alt warning-icon-compact"></i>
          <span className="warning-message-compact">{message}</span>
        </div>

        {/* Close button */}
        <button
          type="button"
          className="warning-close-btn-compact"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default DuplicateEntryWarning;